export default "__VITE_ASSET__7df96a07__"